const collectionManageRouter = {
  path: "/collection",
  name: "集合管理",
  meta: { title: "集合管理", icon: "el-icon-folder" },
  redirect: "/collection/page",
  component: () => import("../../views/collectionManage/index"),
  children: [
    {
      path: "/collection/page",
      name: "页面管理",
      meta: { title: "页面管理" },
      redirect: "/collection/page/list",
      component: () => import("../../views/collectionManage/pageManage/index"),
      children: [
        {
          path: "/collection/page/list",
          name: "页面列表",
          hidden: true,
          meta: { activePath: "/collection/page", title: "页面列表" },
          component: () =>
            import("../../views/collectionManage/pageManage/list")
        },
        {
          path: "/collection/page/create",
          name: "新建页面",
          hidden: true,
          meta: {
            activePath: "/collection/page",
            title: "新建页面",
            layoutBackTo: "/collection/page/list",
            layoutBackLabel: "返回页面列表",
          },
          component: () =>
            import("../../views/collectionManage/pageManage/createOrEdit")
        },
        {
          path: "/collection/page/edit/:id",
          name: "编辑页面",
          hidden: true,
          meta: {
            activePath: "/collection/page",
            title: "编辑页面",
            layoutBackTo: "/collection/page/list",
            layoutBackLabel: "返回页面列表",
          },
          component: () =>
            import("../../views/collectionManage/pageManage/createOrEdit")
        },
        {
          path: "/collection/page/info/:id",
          name: "查看页面",
          hidden: true,
          meta: {
            activePath: "/collection/page",
            title: "查看页面",
            layoutBackTo: "/collection/page/list",
            layoutBackLabel: "返回页面列表",
          },
          component: () =>
            import("../../views/collectionManage/pageManage/info.vue")
        }
      ]
    },
    {
      path: "/collection/style",
      name: "样式管理",
      meta: { title: "样式管理" },
      component: () =>
        import("../../views/collectionManage/styleManage/index.vue")
    },
    {
      path: "/collection/classify",
      name: "分类管理",
      meta: { title: "分类管理" },
      redirect: "/collection/classify/list",
      component: () =>
        import("../../views/collectionManage/classifyManage/index"),
      children: [
        {
          path: "/collection/classify/list",
          name: "分类列表",
          hidden: true,
          meta: { activePath: "/collection/classify", title: "分类列表" },
          component: () =>
            import("../../views/collectionManage/classifyManage/list")
        },
        {
          path: "/collection/classify/create",
          name: "新建分类",
          hidden: true,
          meta: {
            activePath: "/collection/classify",
            title: "新建分类",
            layoutBackTo: "/collection/classify/list",
            layoutBackLabel: "返回分类列表",
          },
          component: () =>
            import("../../views/collectionManage/classifyManage/createOrEdit")
        },
        {
          path: "/collection/classify/edit/:id",
          name: "编辑分类",
          hidden: true,
          meta: {
            activePath: "/collection/classify",
            title: "编辑分类",
            layoutBackTo: "/collection/classify/list",
            layoutBackLabel: "返回分类列表",
          },
          component: () =>
            import("../../views/collectionManage/classifyManage/createOrEdit")
        },
        {
          path: "/collection/classify/info/:id",
          name: "查看分类",
          hidden: true,
          meta: {
            activePath: "/collection/classify",
            title: "查看分类",
            layoutBackTo: "/collection/classify/list",
            layoutBackLabel: "返回分类列表",
          },
          component: () =>
            import("../../views/collectionManage/classifyManage/info")
        },
        {
          path: "/collection/classify/resources/:id",
          name: "资源列表",
          hidden: true,
          meta: {
            activePath: "/collection/classify",
            title: "资源列表",
            layoutBackTo: "/collection/classify/list",
            layoutBackLabel: "返回分类列表",
          },
          component: () =>
            import("../../views/collectionManage/classifyManage/resources")
        },
        {
          path: "/collection/classify/resourcesCreate/:id",
          name: "新建资源",
          hidden: true,
          meta: {
            activePath: "/collection/classify",
            title: "新建资源",
            layoutBackTo: "/collection/classify/list",
            layoutBackLabel: "返回分类列表",
          },
          component: () =>
            import(
              "../../views/collectionManage/classifyManage/resourcesCreate"
            )
        }
      ]
    }
  ]
};
export default collectionManageRouter;
